import { em } from 'polished'
import PropTypes from 'prop-types'
import React from 'react'

import { Col } from 'styles/components/layout'

import { ColStyled, LegendItem, LegendTitle, RowStyled } from './styles'

const CartLegend = ({ texts }) => {
  return (
    <RowStyled>
      <Col width={{ xs: 1, md: `auto` }} flexGrow={{ md: 1 }}>
        <LegendTitle dangerouslySetInnerHTML={{ __html: texts.title }} />
      </Col>
      <ColStyled width={{ xs: 9 / 12, md: 0 }} display={{ md: 'none' }}>
        <LegendItem dangerouslySetInnerHTML={{ __html: texts.item }} />
      </ColStyled>
      <Col
        width={{ xs: 0, md: em(210), lg: em(289) }}
        display={{ xs: 'none', md: 'block' }}
      >
        <LegendItem dangerouslySetInnerHTML={{ __html: texts.quantity }} />
      </Col>
      <ColStyled width={{ xs: 3 / 12, md: em(125), lg: em(197) }}>
        <LegendItem
          isLast={true}
          dangerouslySetInnerHTML={{ __html: texts.price }}
        />
      </ColStyled>
    </RowStyled>
  )
}

CartLegend.propTypes = {
  texts: PropTypes.object.isRequired,
}

export default React.memo(CartLegend)
